import { Link } from 'react-router-dom'

import styles from './WelcomeCard.module.scss'

const WelcomeCard = ({ handleClick }) => (
  <Link
    to="/notificationPreferences"
    className={styles.notification}
    onClick={handleClick}
  >
    <div className={styles.content}>
      <div className={styles.title}>
        <span role="img" aria-label="Hello!">
          👋
        </span>
        {'  '}
        Welcome to notification center!
      </div>
      <div className={styles.description}>
        Messages and reviews from your guests will be shown here. To set up which kind of
        notifications you want to see, click on the button below.
      </div>
      <button className={styles.button}>Set up notifications</button>
    </div>
  </Link>
)

export default WelcomeCard
